(function(){
    angular.module('Directives').directive('packagesTableDirective', packagesTableDirective);
    packagesTableDirective.$inject = ['Units'];

    function packagesTableDirective(Units){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/packagesTable.html',
            scope: {
                data: '='
            },
            link: packagesTableLink
        }

        function packagesTableLink($scope, $attrs, $elments){
            angular.forEach($scope.data.packages, pack => {
                angular.extend(pack, getFormattedItemUnits(pack));
            });

            if($scope.data.packages.length > 0) {
                $scope.data.totalCubicWeightFormatted = `${$scope.data.totalCubicWeight || 0} ${getShortWeight($scope.data.packages[0].weightUnit).toUpperCase()}`;
                $scope.data.totalDeadWeightFormatted = `${$scope.data.totalDeadWeight || 0} ${getShortWeight($scope.data.packages[0].weightUnit).toUpperCase()}`;
            }
        }

        function getFormattedItemUnits(item) {
            const measureUnit = getShortMeasure(item.measureUnit).toUpperCase();
            const weightUnit = getShortWeight(item.weightUnit).toUpperCase();
            return {
                widthFormatted: `${decimalCeil(item.width)} ${measureUnit}`,
                lengthFormatted: `${decimalCeil(item.length)} ${measureUnit}`,
                heightFormatted: `${decimalCeil(item.height)} ${measureUnit}`,
                weightFormatted: `${decimalCeil(item.weight)} ${weightUnit}`,
                cubicWeightFormatted: `${decimalCeil(item.cubicWeight)} ${weightUnit}`,
                totalCubicWeightFormatted: `${decimalCeil(item.totalCubicWeight)} ${weightUnit}`,
                totalDeadWeightFormatted: `${decimalCeil(item.totalDeadWeight)} ${weightUnit}`
            }
        }

        function decimalCeil(num) {
            return Math.ceil(num * 100) / 100;
        }

        function getShortWeight(value) {
            const unit = Units.weightUnit.find(unit => unit.value === value || unit.full === value || unit.short === value) || null;
            return unit ? unit.short : '';
        }

        function getShortMeasure(value) {
            const unit = Units.measureUnit.find(unit => unit.value === value || unit.full === value || unit.short === value) || null;
            return unit ? unit.short : '';
        }
        
    }
})()


// WEBPACK FOOTER //
// ./js/directives/packagesTableDirective.js